// src/components/Prerolls/PrerollsPage.jsx
import React, { useState, useCallback } from 'react'
import PrerollsList from './PrerollsList'
import PrerollFormModal from './PrerollsFormModal'
import '../../css/prerollsTabs.css'

const tabs = ['audio','video']

const PrerollsPage = () => {
  const [tab,setTab]         = useState('audio')
  const [show,setShow]       = useState(false)
  const [editing,setEditing] = useState(null)
  const [refresh,setRefresh] = useState(0)

  const openCreate = () => { setEditing(null); setShow(true) }
  const openEdit   = useCallback(r => { setEditing(r); setShow(true) },[])
  const onSaved    = () => { setRefresh(k=>k+1) }

  return (
    <>
      <nav className="rr-tabs">
        {tabs.map(t => (
          <button key={t}
            className={`rr-tab ${tab===t?'active':''}`}
            onClick={()=>setTab(t)}
          >{t.toUpperCase()}</button>
        ))}
      </nav>

      <PrerollsList
        key={tab}
        mediaType={tab}
        onEdit={openEdit}
        onChange={onSaved}
        refreshKey={refresh}
      />

      <button className="fab-add" onClick={openCreate}>＋</button>

      <PrerollFormModal
        open={show}
        onClose={()=>setShow(false)}
        defaultType={tab}
        editing={editing}
        onSaved={onSaved}
      />
    </>
  )
}

export default PrerollsPage
